export const TRANSLATE_FILE_ACCEPT = '.txt,.md,.docx,.pdf';

export const TRANSLATE_ACTIVE_JOB_STORAGE_KEY = 'translate.activeFileJob';
export const ACTIVE_JOB_STATUSES = ['queued', 'running'] as const;

export const JOB_POLL_INITIAL_SECONDS = 2;
export const JOB_POLL_BACKOFF_FACTOR = 1.5;
export const JOB_POLL_MAX_SECONDS = 10;
export const JOB_POLL_MAX_ERRORS = 5;

export const RESULT_PREVIEW_MAX_CHARS = 20_000;
